import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useGetRequestDetail from './useGetRequestDetail';
import IssuanceUniversityCardProgressView from './IssuanceUniversityCardProgressView';
import routes from '@/presentation/components/Routes/routingMap';

const IssuanceUniversityCardProgressViewController = () => {
  const {
    procedure,
    request,
    isLoading,
    showAnulateProgress,
    isLoadingCancel,
    isLoadingActivatePayment,
    isSuccessActivatePayment,
    handlerCloseModalProgress,
    handlerOkModalProgress,
    handlerShowAnulateProgress,
    handlerActivatePayment,
    campus,
    phone,
    amountDelivery,
    deliveryMode,
    showActivatedPaymentModal,
    setShowActivatedPaymentModal
  } = useGetRequestDetail();

  const history = useHistory();

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.issuancefuniversitycard
            .procedureprogress
        }${'?status=finalizado'}`
      );
    }

    if (request?.status?.name === 'No procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.issuancefuniversitycard
            .procedureprogress
        }${'?status=Finalizadonoprocede'}`
      );
    }
  }, [request]);

  return (
    <IssuanceUniversityCardProgressView
      isLoading={isLoading}
      request={request}
      procedure={procedure}
      handlerShowAnulate={handlerShowAnulateProgress}
      handlerCloseModal={handlerCloseModalProgress}
      handlerOkModalProgress={handlerOkModalProgress}
      handlerBackButton={handlerBackButton}
      handlerActivatePayment={handlerActivatePayment}
      showAnulate={showAnulateProgress}
      isLoadingCancel={isLoadingCancel}
      isLoadingActivatePayment={isLoadingActivatePayment}
      isSuccessActivatePayment={isSuccessActivatePayment}
      campus={campus}
      phone={phone}
      amountDelivery={amountDelivery}
      deliveryMode={deliveryMode}
      showActivatedPaymentModal={showActivatedPaymentModal}
      setShowActivatedPaymentModal={setShowActivatedPaymentModal}
    />
  );
};

export default IssuanceUniversityCardProgressViewController;
